function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function defaultDispose() {}

export var Cache = /*#__PURE__*/function () {
  function Cache() {
    var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Infinity;
    var dispose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDispose;

    _classCallCheck(this, Cache);

    this.max = max;
    this.dispose = dispose;
    this.map = new Map();
    this.newest = null;
    this.oldest = null;
  }

  _createClass(Cache, [{
    key: "has",
    value: function has(key) {
      return this.map.has(key);
    }
  }, {
    key: "get",
    value: function get(key) {
      var node = this.getNode(key);
      return node && node.value;
    }
  }, {
    key: "getNode",
    value: function getNode(key) {
      var node = this.map.get(key);

      if (node && node !== this.newest) {
        var older = node.older,
            newer = node.newer;

        if (newer) {
          newer.older = older;
        }

        if (older) {
          older.newer = newer;
        }

        node.older = this.newest;
        node.older.newer = node;
        node.newer = null;
        this.newest = node;

        if (node === this.oldest) {
          this.oldest = newer;
        }
      }

      return node;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var node = this.getNode(key);

      if (node) {
        return node.value = value;
      }

      node = {
        key: key,
        value: value,
        newer: null,
        older: this.newest
      };

      if (this.newest) {
        this.newest.newer = node;
      }

      this.newest = node;
      this.oldest = this.oldest || node;
      this.map.set(key, node);
      return node.value;
    }
  }, {
    key: "clean",
    value: function clean() {
      while (this.oldest && this.map.size > this.max) {
        this.delete(this.oldest.key);
      }
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var node = this.map.get(key);

      if (node) {
        if (node === this.newest) {
          this.newest = node.older;
        }

        if (node === this.oldest) {
          this.oldest = node.newer;
        }

        if (node.newer) {
          node.newer.older = node.older;
        }

        if (node.older) {
          node.older.newer = node.newer;
        }

        this.map.delete(key);
        this.dispose(node.value, key);
        return true;
      }

      return false;
    }
  }]);

  return Cache;
}();